import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent {

    private router = inject(Router);

    start(): void {
        this.router.navigate(['/']);
    }

}
